module.exports = __webpack_public_path__ + "static/media/list-grid-icon.ddecb467.svg";